var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { editorSlice } from 'app/stores/editor';
export const setActiveTool = createAsyncThunk('editor/setActiveTool', (toolId, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    if (state.editor.activeTool === toolId) {
        const allowToolDeselection = configGet('allowToolDeselection', true);
        if (allowToolDeselection) {
            dispatch(editorSlice.actions.setTool({ toolId: undefined }));
        }
        return;
    }
    const { availableTools } = state.editor;
    const isValidTool = availableTools.findIndex(tool => tool.id === toolId) > -1;
    if (!isValidTool) {
        return;
    }
    if (state.editor.activeController !== 'image-annotate') {
        dispatch(editorSlice.actions.setController({
            controller: 'image-annotate',
        }));
    }
    dispatch(editorSlice.actions.setTool({ toolId }));
}));
export const clearTool = createAsyncThunk('editor/clearTool', (_, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    if (!state.editor.activeTool) {
        return;
    }
    if (state.editor.activeController !== 'image-annotate') {
        dispatch(editorSlice.actions.setController({
            controller: 'image-annotate',
        }));
    }
    dispatch(editorSlice.actions.setTool({ toolId: null }));
}));
